import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Form, Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import { storeData, updateData } from '~/store/modules/safras/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.safras);

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        idsafra: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),
        descricaosafra: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        statussafra: Yup.string()
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="idsafra"
            label={t('s.cadastro.safra.idsafra')}
            disabled={!create}
            type="number"
          />

          <Input
            name="descricaosafra"
            label={t('s.cadastro.safra.descricaosafra')}
          />

          <Select
            name="statussafra"
            label={t('s.cadastro.safra.statussafra')}
            options={[
              { value: 'L', label: t('s.geral.opcoes.liberado') },
              { value: 'B', label: t('s.geral.opcoes.bloqueado') },
              { value: 'C', label: t('s.geral.opcoes.cancelado') },
            ]}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
